export const NUMBER_OF_LOADING_PATIENTS = 101
export const MAX_NUMBER_OF_RECENTLY_VIEWED_PATIENTS = 30
